import React from 'react';

interface PageWrapperProps {
  children: React.ReactNode;
  className?: string;
}

const PageWrapper: React.FC<PageWrapperProps> = ({ children, className = '' }) => {
  return (
    <div className={`h-full lg:flex lg:flex-col lg:gap-8 space-y-4 sm:space-y-6 ${className}`}>
      {children}
    </div>
  );
};

export default PageWrapper;

